import Vue from "vue";
import App from "@/App";
import router from "@/router";
import store from "@/store";
import VueLodash from "vue-lodash";
import BootstrapVue from "bootstrap-vue";
import { VueReCaptcha } from "vue-recaptcha-v3";
import VCalendar from 'v-calendar';

import globals from "./globals";
import Popper from "popper.js";

import Notifications from "vue-notification";
import { ClientTable } from "vue-tables-2";

import { vueTableOptions } from "@/utils/helpers";
import VueFormWizard from "vue-form-wizard";

Vue.use(ClientTable, vueTableOptions);
Vue.use(Notifications);
Vue.use(VCalendar, {
  componentPrefix: 'v'
});
// Required to enable animations on dropdowns/tooltips/popovers
Popper.Defaults.modifiers.computeStyle.gpuAcceleration = false;
import "vue-form-wizard/dist/vue-form-wizard.min.css";
Vue.config.productionTip = false;
Vue.use(VueFormWizard);
Vue.use(BootstrapVue);

import { captchaKey } from "@/utils/helpers";

captchaKey().then(key => {
  Vue.use(VueReCaptcha, { siteKey: key });
});

import VeeValidate from "vee-validate";

Vue.use(VeeValidate);

const validateDictionary = {
  pl: {
    messages: {
      email: () => "To nie jest email",
      required: () => "To pole jest wymagane",
      numeric: () => "To nie jest numer",
      phoneNumber: () => "To nie jest numer telefonu",
      regex: () => "Pole nie zgadza sie z wymaganiami",
      min: (_field, arg) => `Wymagane minimum ${arg} znaków`,
      max: (_field, arg) => `Maksymalnie ${arg} znaków`
    }
  }
};
VeeValidate.Validator.extend("phoneNumber", {
  getMessage: _field => "To nie jest numer telefonu",
  validate: value =>
    /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{3,6}$/.test(value)
});

VeeValidate.Validator.localize("pl");
VeeValidate.Validator.localize("pl", validateDictionary.pl);

Vue.use(VueLodash, {
  name: "lodash"
});

// Global RTL flag
Vue.mixin({
  data: globals
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
